import React from 'react';
import { Container } from '@mui/material';
import ABAAssessmentTemplateGenerator from '../components/ABAAssessmentTemplateGenerator';

const ABAAssessmentTemplateGeneratorPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <ABAAssessmentTemplateGenerator />
    </Container>
  );
};

export default ABAAssessmentTemplateGeneratorPage;